<template>
  <dash-board-layout :active="8" :fulid="true">
    <div class="verification section-padding">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center">
          <div class="col-xl-6">
            <div class="auth-form card">
              <div class="card-header">
                <h4 class="card-title">Select the certification type</h4>
              </div>
              <div class="card-body">
                <div class="add-bank-card">
                  <div class="row my-4">
                    <div class="col-md-6">
                      <!-- select_bank_type -->
                      <router-link to="/reg/inc_cert/step1" class="d-person">
                        <div class="media">
                          <span class="mr-3"><i class="fa fa-bank"></i></span>
                          <div class="media-body">
                            <h4 class="mt-0 mb-3">An institution or company</h4>
                            <!-- <p class="text-muted">It's coming online</p> -->
                            <!-- <p>
                              Use bank account to make purchase and sells.
                              Prices are locked today. Trades may take 4-5 days
                              to process
                            </p>
                            <p class="text-muted">
                              Recommended for invest large amount
                            </p> -->
                          </div>
                        </div>
                      </router-link>
                    </div>
                    <div class="col-md-6">
                      <router-link to="/reg/person/step1" class="d-bank">
                        <div class="media">
                          <span class="mr-3"
                            ><i class="fa fa-credit-card"></i
                          ></span>
                          <div class="media-body">
                            <h4 class="mt-0 mb-3">Personal</h4>
                            <!-- <p>
                              Use any visa or mastercard debit card to make
                              small investment. Add a bank or wallet to sell
                            </p>
                            <p class="text-muted">
                              Recommended for invest small amount
                            </p> -->
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../../components/layouts/DashBoardLayout.vue";
import {
  otc_auth_status,
  get_persional_info,
  att_persional_info,
} from "../../../plugins/api/account_otc";
export default {
  components: { DashBoardLayout },
  created() {
    get_persional_info().then((res_query) => {
      if (res_query.data && res_query.data.name) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      } else {
        this.$alert("Please select your certification type", "prompt", {
          confirmButtonText: "Enter",
          callback: (action) => {},
        });
      }
    });
  },
};
</script>
